__webpack_require__.p = "/views-scroll/referrals-hub/";